// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullscreenPopup__popup-a0d495 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--base-0);
  display: grid;
  align-content: start;
  height: 100vh;
  width: 100vw;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/FullscreenPopup/FullscreenPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AACF","sourcesContent":[".popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--base-0);\n  display: grid;\n  align-content: start;\n  height: 100vh;\n  width: 100vw;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `FullscreenPopup__popup-a0d495`
};
module.exports = ___CSS_LOADER_EXPORT___;
